module.exports = __webpack_public_path__ + "images/application/i-error-1c5cc1ab.svg";